export class AppCard extends HTMLElement {
  static get observedAttributes() {
    return ["title", "subtitle"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const title = this.getAttribute("title") || "";
    const subtitle = this.getAttribute("subtitle") || "";
    const content = this.innerHTML;

    // Avoid recursive wrapping
    const existingCard = this.querySelector(".card-content-wrap");
    if (existingCard) return;

    this.innerHTML = `
      <div class="card card-content-wrap">
        ${title ? `
          <div style="margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid var(--color-border-subtle);">
            <h3 class="text-subsection-title">${title}</h3>
            ${subtitle ? `<p class="text-caption" style="margin-top: 2px;">${subtitle}</p>` : ""}
          </div>
        ` : ""}
        <div>${content}</div>
      </div>
    `;
  }
}

if (!customElements.get("app-card")) {
  if (!customElements.get("app-card")) {
    customElements.define("app-card", AppCard);
  }
}

export class AppKpiCard extends HTMLElement {
  static get observedAttributes() {
    return ["title", "value", "unit", "trend", "status"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const title = this.getAttribute("title") || "Indicador";
    const value = this.getAttribute("value") || "0";
    const unit = this.getAttribute("unit") || "";
    const trend = this.getAttribute("trend") || "";
    const status = this.getAttribute("status") || "default"; // 'success', 'warning', 'danger', 'info', 'default'

    let statusStyle = "";
    if (status === "success") statusStyle = "color: var(--status-success-text);";
    if (status === "warning") statusStyle = "color: var(--status-warning-text);";
    if (status === "danger") statusStyle = "color: var(--status-danger-text);";
    if (status === "info") statusStyle = "color: var(--status-info-text);";

    this.innerHTML = `
      <div class="card-kpi">
        <span class="card-kpi-title">${title}</span>
        <div style="display: flex; align-items: baseline; gap: 4px;">
          <span class="card-kpi-value" style="${statusStyle}">${value}</span>
          ${unit ? `<span style="font-family: var(--font-mono); font-size: 0.8125rem; color: var(--color-text-muted);">${unit}</span>` : ""}
        </div>
        ${trend ? `<span class="card-kpi-sub">${trend}</span>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-kpi-card")) {
  if (!customElements.get("app-kpi-card")) {
    customElements.define("app-kpi-card", AppKpiCard);
  }
}
